import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { getDrugTestThemeTokens } from '../themeTokens';

export const OrderPrimaryButton = styled(Button)(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    textTransform: 'none',
    fontWeight: 500,
    fontSize: 13,
    padding: '8px 14px',
    borderRadius: 8,
    backgroundColor: t.violet,
    color: '#fff',
    border: `1px solid ${t.violet}`,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: t.violet,
      filter: 'brightness(0.97)',
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: t.violet,
      color: '#fff',
      opacity: 0.5,
    },
  };
});
